import Location from '@/components/Icon/Location'
import MyLocation from '@/components/Icon/MyLocation'
import VirtualTour from '@/components/Icon/VirtualTour'
import FloorPlan from '@/design-lib/components/Icons/FloorPlan'

import { iconClass } from './styles.css'

type Kind = 'location' | 'floorplan' | 'streetView' | 'virtualTour'

const icon: Record<Kind, React.ReactElement> = {
  floorplan: <FloorPlan />,
  location: <Location />,
  streetView: <MyLocation />,
  virtualTour: <VirtualTour />,
}

type Props = { kind: Kind }

const Icon: React.FC<Props> = (props) => <div className={iconClass}>{icon[props.kind]}</div>

export default Icon
